<template>
  <div class="abcs-select-item" :class="[zsTjTheme]">
    <div ref="select" class="option">
      <img class="en" :src="icon" />
      <SvgIcon class="arrow" iconClass="zs-tj-arrow-down" />
    </div>
    <div ref="tippyContent" class="option-list">
      <div v-for="(value, key) in iconmap" :key="key" class="option-item" @click="handleSelect(key)">
        <img class="icon" :src="value" />
        <div v-if="key !== 'S'" class="line"></div>
      </div>
    </div>
  </div>
</template>
<script>
import tippy from "@/plugins/tippy";
import { mapGetters } from "vuex";

export default {
  name: "AbcsSelectItem",
  props: { icon: { type: String, default: "" }, iconmap: { type: Object, default: () => ({}) } },
  computed: {
    ...mapGetters(["zsTjTheme"])
  },
  mounted() {
    this.initTippy();
  },
  beforeDestroy() {
    this.tippy.destroy();
  },
  methods: {
    initTippy() {
      const target = this.$refs.select;
      const content = this.$refs.tippyContent;
      if (!target || !content) {
        setTimeout(this.initTippy, 50);
        return;
      }
      this.tippy = tippy(target, {
        content,
        arrow: false,
        interactive: true,
        trigger: "click",
        placement: "bottom",
        theme: "tippy-clear-style-theme"
      });
    },
    handleSelect(key) {
      this.tippy.hide();
      this.$emit("change", key);
    }
  }
};
</script>
<style lang="less" scoped>
.abcs-select-item {
  .option {
    border-radius: 23px;
    padding: 4px 5px;
    box-sizing: content-box;
    background-color: #0a0a0c;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 4px;
    cursor: pointer;
    color: #fff;
    .en {
      width: 24px;
      height: 24px;
    }
    .arrow {
      width: 14px;
      height: 14px;
    }
  }

  .option-list {
    display: flex;
    flex-direction: column;
    background-color: #0a0a0c;
    box-sizing: content-box;
    padding: 4px;
    border-radius: 20px;
    row-gap: 7px;
    .option-item {
      position: relative;
      border-radius: 16px;
      width: 60px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background-color 300ms;
      &:hover {
        background-color: rgba(255, 255, 255, 0.08);
      }
      .icon {
        width: 28px;
        height: 28px;
      }
      .line {
        position: absolute;
        bottom: -4px;
        width: 50px;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.14);
      }
    }
  }
}

.abcs-select-item.light {
  .option {
    background: #d2dee3;
    color: #000;
  }

  .option-list {
    background: #d2dee3;
  }
}
</style>
